import PhoneAnimation from './PhoneAnimation';
import SectionHeader from '../components/SectionHeader';
import { FaGithub, FaLinkedin, FaMapMarkerAlt } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import styles from './Contact.module.css';

function Contact() {
  return (
    <div className={styles.contact}>
      <SectionHeader 
        title="Get In Touch" 
        subtitle="Let's connect and collaborate"
      />
      
      <div className={styles.content}>
        <div className={styles.info}>
          <p className={styles.message}>
            I'm based in Rotterdam and work at CGI as a System & Cybersecurity Engineer
            on the IRIS² programme. I'm happy to connect with fellow engineers, exchange
            ideas and discuss collaborations around software and technology.
            Have a question about my work or a project idea? Feel free to reach out.
          </p>

          <div className={styles.contactMethods}>
            <a 
              href="mailto:jonas00101@gmail.com" 
              className={styles.contactItem}
            >
              <MdEmail size={28} />
              <div>
                <h4>Email</h4>
                <p>jonas00101@gmail.com</p>
              </div>
            </a>

            <a 
              href="https://www.linkedin.com/in/joaolopes017/" 
              target="_blank" 
              rel="noreferrer"
              className={styles.contactItem}
            >
              <FaLinkedin size={28} />
              <div>
                <h4>LinkedIn</h4>
                <p>linkedin.com/in/joaolopes017</p>
              </div>
            </a>

            <a 
              href="https://github.com/JoaoLopes017" 
              target="_blank" 
              rel="noreferrer"
              className={styles.contactItem}
            >
              <FaGithub size={28} />
              <div>
                <h4>GitHub</h4>
                <p>github.com/JoaoLopes017</p>
              </div>
            </a>

            <div className={styles.contactItem}>
              <FaMapMarkerAlt size={28} />
              <div>
                <h4>Location</h4>
                <p>Rotterdam, Netherlands</p>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.formContainer}>
          <PhoneAnimation />
          <form 
            action="mailto:jonas00101@gmail.com" 
            method="POST" 
            encType="text/plain"
            className={styles.form}
          >
            <div className={styles.formGroup}>
              <label htmlFor="name">Your Name</label>
              <input 
                type="text" 
                id="name" 
                name="name" 
                placeholder="John Doe" 
                required 
              />
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="email">Your Email</label>
              <input 
                type="email" 
                id="email" 
                name="email" 
                placeholder="john@example.com" 
                required 
              />
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="message">Message</label>
              <textarea 
                id="message" 
                name="message" 
                rows="6" 
                placeholder="Your message here..." 
                required
              ></textarea>
            </div>

            <button type="submit" className={styles.submitBtn}>
              Send Message
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Contact;
